import { useQuery } from '@tanstack/react-query'
import { getUserStudyPlan as queryFn } from '../apis/api-content'
import { useUserCourses } from '../pages/meeting-view/hooks/useCourses'

export const useCourseStudyPlan = (courseId?: string) => {
    const { currentCourse } = useUserCourses()
    const enableSharedContent = !!currentCourse?.courseFlags.enableSharedContent
    const queryKey = ['Study Plan', courseId]

    const {
        data: plan,
        error,
        isLoading,
        ...rest
    } = useQuery({
        queryKey,
        queryFn,
        enabled: !!courseId && enableSharedContent,
        retry: 2,
        staleTime: 1000 * 60 * 60,
        gcTime: 1000 * 60 * 120,
    })

    const currentSessionId = plan?.currentSessionId
    const currentSession = plan?.sessions?.find(({ id }) => currentSessionId === id)
    const firstSession = plan?.sessions?.at(0)

    // Enhanced logic to reliably get the first step ID with proper null checks
    const firstStepId =
        currentSession?.steps && currentSession.steps.length > 0 ? currentSession.steps[0]?.id : undefined

    const findSessionById = (sessionId?: string) => plan?.sessions?.find(({ id }) => id === sessionId)
    const findSessionByStepId = (stepId?: string) =>
        plan?.sessions?.find(session => session.steps.some(({ id }) => id === stepId))
    const findStepById = (stepId?: string) =>
        plan?.sessions?.map(session => session.steps.find(({ id }) => id === stepId)).find(step => step)

    return {
        plan,
        firstSession,
        firstStepId,
        currentSessionId,
        currentSession,
        findSessionByStepId,
        findSessionById,
        findStepById,
        queryKey,
        error,
        isLoading,
        isContentSharingEnabled: enableSharedContent,
        ...rest,
    }
}
